import React, { FunctionComponent, ReactElement } from "react";
import classnames from "classnames";

import "./FeatureGroup.scss";

export const FeatureGroupContent: FunctionComponent<{}> = ({ children }) => {
    return <div className="feature_group_box">{children}</div>;
};

export interface FeatureGroupProps {
    className?: string;
}

const FeatureGroup: FunctionComponent<FeatureGroupProps> = ({ className, children }) => {
    return <div className={classnames("feature_group_container", className)}>{children}</div>;
};

export default FeatureGroup;
export * from "./FeatureGroupNumericTitle";
export * from "./FeatureGroupIconTitle";
export * from "./FeatureGroupBoxedIconTitle";
